import { useContext } from "react"
import { useLocation } from "react-router-dom"
import { NarrowLayout } from "source/Layout"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { PostDonateStatus } from "../donation_form/components/PostDonateStatus"
import { PostDonateSuccessLinks } from "../donation_form/components/PostDonateSuccessLinks"

export function DonationProcessing() {
  const {
    current_person: {
      data: {
        attributes: { first_name, email_address, address },
      },
    },
    current_organization: { contact_website },
  } = useContext(ServerRenderedProps)

  const {
    state: { nondeterministicError },
  } = useLocation()

  const heading = nondeterministicError
    ? "Donation processing"
    : `Thank you, ${first_name}!`

  const message = nondeterministicError
    ? `Your donation has been received, and a receipt will be sent to ${email_address} when processing is complete.`
    : `Your donation is processing, and a receipt will be sent to ${email_address}.`

  return (
    <NarrowLayout>
      <PostDonateStatus
        status="processing"
        heading={heading}
        message={message}
        actions={
          <PostDonateSuccessLinks
            donorAddress={address}
            orgWebsite={contact_website}
          />
        }
      />
    </NarrowLayout>
  )
}
